/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import type {
	useBlueprintTypeEditorEditorLabelsQuery as useBlueprintTypeEditorEditorLabelsQuery$data,
	useBlueprintTypeEditorEditorLabelsQueryVariables as useBlueprintTypeEditorEditorLabelsQuery$variables,
} from './__types__/useBlueprintTypeEditorEditorLabelsQuery.ts';
import { PREDEFINED_BLUEPRINT_TYPES_TITLES } from './constants.ts';

export const getBlueprintType = (labels) => {
	for (const label of labels) {
		const value = PREDEFINED_BLUEPRINT_TYPES_TITLES[label];
		if (value !== undefined) return label;
	}

	return '';
};

export const getBlueprintFromLabels = (data) => {
	const labels = data?.content?.nodes[0]?.labels?.nodes?.map((x) => x.name) ?? [];
	return getBlueprintType(labels);
};

export const useBlueprintType = (contentId: string, skip: boolean = false) => {
	const { data, loading, error } = useQuery<
		useBlueprintTypeEditorEditorLabelsQuery$data,
		useBlueprintTypeEditorEditorLabelsQuery$variables
	>(
		gql`
			query useBlueprintTypeEditorEditorLabelsQuery($contentId: ID!) {
				content(id: $contentId) {
					nodes {
						id
						labels {
							nodes {
								id
								name
							}
						}
					}
				}
			}
		`,
		{
			skip,
			variables: { contentId },
		},
	);

	if (loading || error) {
		return '';
	}

	return getBlueprintFromLabels(data);
};
